export default class Chips
{
    static EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    constructor() {
        this.chips = {};

        document.querySelectorAll('.chips').forEach(chips => {
            const input = chips.querySelector('input');
            const id = input.getAttribute('id');

            this.chips[id] = {
                values: [...chips.querySelectorAll('.chip')].map(chip => chip.textContent.trim()).filter(Boolean),
                container: chips,
                input: input
            };

            this.chips[id].container.addEventListener('input', e => {
                const hasSelectedToBeDeleted = this.chips[id].container.querySelector('.chip--to-be-removed');
                if (hasSelectedToBeDeleted) {
                    hasSelectedToBeDeleted.classList.remove('chip--to-be-removed');
                }
            });

            this.chips[id].container.addEventListener('click', e => {
                const target = e.target;

                if (target.closest('.chip__remove')) {
                    target.closest('.chip').remove();
                    this.chips[id].values = [...chips.querySelectorAll('.chip')].map(chip => chip.textContent.trim()).filter(Boolean);
                    this.chips[id].container.closest('form').querySelector('.button--success').classList.remove('button--disabled');
                }
            });

            this.chips[id].input.addEventListener('keydown', e => {
                if (['Enter', ',', ' ', 'Tab'].includes(e.key)) {
                    if (e.target.value.trim().length) {
                        e.preventDefault();
                        this.addChip(id, e.target.value.trim());
                    }
                } else if (e.key === 'Backspace' && !e.target.value && this.chips[id].values.length) {
                    const chips = this.chips[id].container.querySelectorAll('.chip');
                    const totalChips = chips.length;

                    if (totalChips) {
                        if (chips[totalChips - 1].classList.contains('chip--to-be-removed')) {
                            this.chips[id].values.pop();
                            chips[chips.length - 1].remove();
                            this.chips[id].container.closest('form').querySelector('.button--success').classList.remove('button--disabled');
                        } else {
                            chips[totalChips - 1].classList.add('chip--to-be-removed');
                        }
                    }
                }
            });

            this.chips[id].input.addEventListener('paste', e => {
                e.preventDefault();
                const pastedData = (e.clipboardData || window.clipboardData).getData('text');
                const splitValues = pastedData.split(/[\s,;\n]+/).filter(i => i);

                if (splitValues.length) {
                    splitValues.forEach(value => this.addChip(id, value));
                }
            });

            this.chips[id].input.addEventListener('blur', e => {
                const hasSelectedToBeDeleted = this.chips[id].container.querySelector('.chip--to-be-removed');
                if (hasSelectedToBeDeleted) {
                    hasSelectedToBeDeleted.classList.remove('chip--to-be-removed');
                }

                if (e.target.value.trim()) {
                    e.preventDefault();
                    this.addChip(id, e.target.value.trim());
                }
            });
        });
    }

    addChip(id, value) {
        if (Chips.EMAIL_REGEX.test(value) && !this.chips[id].values.includes(value)) {
            const hasSelectedToBeDeleted = this.chips[id].container.querySelector('.chip--to-be-removed');
            if (hasSelectedToBeDeleted) {
                hasSelectedToBeDeleted.classList.remove('chip--to-be-removed');
            }

            this.chips[id].values.push(value);
            this.chips[id].input.value = '';
            this.chips[id].input.insertAdjacentHTML('beforebegin', `
            <span class="chip">
                ${value}
                <button type="button" class="chip__remove" aria-label="${__('cta_delete')}">
                    <span class="icon icon--remove" aria-hidden="true"></span>
                </button>
            </span>
            `);
        } else {
            const formGroup = this.chips[id].container.closest('.form__group');

            formGroup.closest('form').classList.add('form__error');
            formGroup.classList.add('form__group--error');
            formGroup.querySelector('.error').textContent = __('error_enter_valid_email_address');
        }
    }
}